<section class="sync-popup" *ngIf="visible && status" [class.sync-popup--error]="failedTables > 0">
  <button class="sync-popup__close" type="button" aria-label="Dismiss sync progress" (click)="dismiss()">&times;</button>
  <div class="sync-popup__eyebrow">{{ failedTables ? 'Workspace sync needs attention' : 'Initial workspace sync' }}</div>
  <h2 class="sync-popup__title">
    {{ failedTables ? 'Some data could not be synced' : (completedTables === totalTables ? 'Workspace is ready' : 'Preparing your workspace') }}
  </h2>
  <p class="sync-popup__message">{{ status.message }}</p>

  <div class="sync-popup__current" *ngIf="currentTable && currentTable.tableName && !currentTable.tableCompleted">
    <div>
      <span>Current table</span>
      <strong>{{ currentTable.tableLabel || currentTable.tableName }}</strong>
    </div>
    <div class="sync-popup__current-count" *ngIf="currentTable.expectedItemCount != null">
      <strong>{{ (currentTable.returnedItemCount || 0) | number }} / {{ currentTable.expectedItemCount | number }}</strong>
      <span>{{ currentTableProgress }}%</span>
    </div>
    <div class="sync-popup__current-count" *ngIf="currentTable.expectedItemCount == null && currentTable.pageNumber">
      <strong>Page {{ currentTable.pageNumber }}</strong>
    </div>
  </div>

  <div class="sync-popup__details">
    <span>{{ completedTables }} of {{ totalTables }} tables ready</span>
    <strong>{{ progress }}%</strong>
  </div>

  <div class="sync-popup__progress" role="progressbar" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
    <span [style.width.%]="progress"></span>
  </div>

  <p class="sync-popup__helper" *ngIf="!failedTables">
    You can keep using the app. Some lists may fill in gradually during first setup.
  </p>
  <p class="sync-popup__helper" *ngIf="failedTables">
    {{ failedTables }} {{ failedTables === 1 ? 'table needs' : 'tables need' }} attention. Completed data has been preserved.
  </p>

  <div class="sync-popup__actions">
    <button class="sync-popup__button sync-popup__button--secondary" type="button" (click)="openDetails()">View details</button>
    <button *ngIf="failedTables" class="sync-popup__button sync-popup__button--primary" type="button" [disabled]="retrying" (click)="retry()">
      {{ retrying ? 'Retrying...' : 'Retry failed' }}
    </button>
  </div>
</section>
